import React from 'react';
import PropTypes from "prop-types";
import {observer} from "mobx-react";
import {Input} from "@morningtrain/react-fields";
import useFilterValue from "../hooks/use-filter-value";
import useWillConstrain from "../hooks/use-will-constrain";
import debounce from "lodash/debounce";

function SearchFilter(props) {

    const [hasFocus, setHasFocus] = React.useState(false);

    const [value, setValue] = useFilterValue(props.name, null, 'value', hasFocus);

    useWillConstrain(props.name, value);

    const handleChange = debounce((nextValue) => {
        setValue(nextValue)
    }, 400, {leading: false})

    return (
        <Input placeholder={props.placeholder}
               className={props.className}
               label={props.label}
               type={props.type}
               defaultValue={value}
               onFocus={() => setHasFocus(true)}
               onBlur={() => setHasFocus(false)}
               onChange={handleChange}/>
    );
}

SearchFilter.defaultProps = {
    label: null,
    name: 'search',
    type: 'search',
    placeholder: 'Søg...',
};

SearchFilter.propTypes = {
    className: PropTypes.string,
    label: PropTypes.node,
    name: PropTypes.string,
    type: PropTypes.string,
    placeholder: PropTypes.string,
};

export default observer(SearchFilter);
